import React, { useEffect, useState } from 'react';
import { FiltroTypes } from './Funcs';
import { TextsProps } from '../../database/txt.interface';
import { useSelector } from 'react-redux';
import { AlertDialogDescription } from '@radix-ui/react-alert-dialog';
import { P } from '../Paciente/MapaDor/styles';
import DatePickerWithRange from "./DataPicker";
import MultiSelect from "./MultiSelect";
import Tags from "./Tags";
import Calendar from '../../assets/kinologyIcons/svg/calendar_month.svg';
import Cargo from '../../assets/kinologyIcons/svg/cargo.svg';
import Sexo from '../../assets/kinologyIcons/svg/sexo.svg';
import EvaluatorDash from '../../assets/kinologyIcons/svg/evaluator_dash.svg';
import Fitness from '../../assets/kinologyIcons/svg/fitness_center.svg';
import NivelCond from '../../assets/kinologyIcons/svg/nivel_cond.svg';
import DoorOpen from '../../assets/kinologyIcons/svg/door_open.svg';
import Management from '../../assets/kinologyIcons/svg/management.svg';
import {ReactComponent as EditFilterPanel} from '../../assets/kinologyIcons/svg/edit.svg';

import {ListCheck} from "lucide-react";
import { format, startOfMonth } from 'date-fns';

interface CustomizeFilterProps {
	icon?: any;
	onFilterChange?: (label: string, value: any) => void;
	setEditPanel?: ()=> void;
	defaultFilter?: FiltroTypes;
	GraphType?: string;
	customPanel: boolean;
	editPanel?:boolean;
	clear?: boolean;
	appliedFilters?: any;
	
};



const CustomizeFiltersPanel: React.FC<CustomizeFilterProps> = ({
	onFilterChange, 
	setEditPanel,
	icon, 
	defaultFilter, 
	GraphType,
	customPanel,
	editPanel,
	clear,
	appliedFilters

})=> {

	const current_language: TextsProps = useSelector(
			(state: any) => state.configs.current_language
		);
	
		let exercicios: any = useSelector(
			(state: any) => state.exercicios.exercicios
		);
	
		let cargos_dynalabs = useSelector(
			(state: any) => state.dashboard.cargos
		);
	
		let protocolos_dynalabs = useSelector(
			(state: any) => state.manage_protocol.protocolos
		);
	
		let avaliadores = useSelector(
			(state: any) => state.dashboard.avaliadores
		);
	
		let etiquetas = useSelector(
			(state: any) => state.dashboard.etiquetas
		);
	
		let entrance_door_data = useSelector(
			(state: any) => state.dashboard.entrance_door_data
		);
	
		let gerencias = useSelector((state: any) => state.dashboard.gerencias);

		const [clearFilter, setClearFilter ] = useState(false);
		const [clearTag, setClearTag ] = useState(false);

		useEffect(()=>{
			if(clear){
				setClearFilter(true)
				setClearTag(true)
				setTimeout(()=>{setClearFilter(false)},500) 
			}
		},[clear]);

		
		const mesesAbreviados = [
			"Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];

		const getLastThreeMonthsAbbr = () => mesesAbreviados.map((m, i, a) => a[(new Date().getMonth() - 2 + i + 12) % 12]).slice(0, 3);

		const ano_atual = new Date().getFullYear();

		useEffect(()=>{
			if(clearFilter){
				onFilterChange?.('ano',[ano_atual])
				onFilterChange?.('mes', [getLastThreeMonthsAbbr().reverse()[0]])
				onFilterChange?.('exercicio', [])
				onFilterChange?.('protocolo', [])
				onFilterChange?.('cargo', [])
				onFilterChange?.('sexo', [])
				onFilterChange?.('condicionamento', [])
				onFilterChange?.('avaliador', [])
				onFilterChange?.('articulacao', [])
				onFilterChange?.('entrance_door_data', [])
				onFilterChange?.('gerencias', [])
				onFilterChange?.('alteracoes', [])
				onFilterChange?.('data', [])
			}

		},[clearFilter]);

		useEffect(()=>{
			if(clearTag){
				onFilterChange?.('etiqueta', [])
			}
		},[clearTag])
	
		const articulacoes = [
			{
				label: "CERVICAL",
				value: "CERVICAL"
			},
			{
				label: "COTOVELO",
				value: "COTOVELO"
			},
			{
				label: "JOELHO",
				value: "JOELHO"
			},
			{
				label: "OMBRO",
				value: "OMBRO"
			},
			{
				label: "PUNHO",
				value: "PUNHO"
			},
			{
				label: "QUADRIL",
				value: "QUADRIL"
			},
			{
				label: "TORNOZELO",
				value: "TORNOZELO"
			},
		]
	
		const sexos = [
			{
				label: "Masculino",
				value: "M"
			},
			{
				label: "Feminino",
				value: "F"
			}
		]
	
		const condicionamentos = [
			{
				label: current_language?.menu_lateral_atleta,
				value: 1
			},
			{
				label: current_language?.menu_lateral_ativo,
				value: 2
			},
			{
				label: current_language?.menu_lateral_pos_operatorio,
				value: 3
			},
			{
				label: current_language?.menu_lateral_sedentario,
				value: 4
			},
			{
				label: current_language?.menu_lateral_idoso,
				value: 5
			},
	
	
		]
	
		const alteracoes = [
			{
				label: "Sem alterações",
				value: "positivo",
				color: "#0CD100"
			},
			{
				label: "Alterações Leves",
				value: "intermediario",
				color: "#FFC530"
			},
			{
				label: "Alterações Significativas",
				value: "negativo_1",
				color: "#E57E00"
			},
			{
				label: "Alterações Graves",
				value: "negativo_2",
				color: "#D12600"
			},
		]
	
		if (exercicios.length > 0) {
			exercicios = exercicios.map((exercicio: any) => {
				exercicio.label = exercicio?.EXERCICIO_TITULO_PT;
				exercicio.value = exercicio.ID_EXERCICIO
				return exercicio;
			})
		}
	
		if (cargos_dynalabs.length > 0) {
			cargos_dynalabs = cargos_dynalabs.map((cargo: any) => {
				cargo.label = cargo.CARGO_TITULO
				cargo.value = cargo.ID_CARGO
				return cargo
			})
		}
	
		if (protocolos_dynalabs.length > 0) {
			protocolos_dynalabs = protocolos_dynalabs.map((protocolo: any) => {
				protocolo.label = protocolo.PROTOCOLO_TITULO_PT
				protocolo.value = protocolo.ID_PROTOCOLO
				return protocolo
			})
		}
	
		if (etiquetas.length > 0) {
			etiquetas = etiquetas.map((etiqueta: any) => {
				etiqueta.label = etiqueta.ETIQUETA_NOME
				etiqueta.value = etiqueta.ID_ETIQUETA
				return etiqueta
			})
		}
	
		if (avaliadores.length > 0) {
			avaliadores = avaliadores.map((avaliador: any) => {
				avaliador.label = avaliador.USUARIO_NOME
				avaliador.value = avaliador.ID_USUARIO
				return avaliador
			})
		}
	
		if (entrance_door_data.length > 0) {
			entrance_door_data = entrance_door_data.map((door: any) => {
				door.label = door.PORTA_ENTRADA_TITULO
				door.value = door.ID_PORTA_ENTRADA
				return door
			})
		}
	
		if (gerencias.length > 0) {
			gerencias = gerencias.map((gerencia: any) => {
				gerencia.label = gerencia.GERENCIA_TITULO
				gerencia.value = gerencia.ID_GERENCIA
				return gerencia
			})
		}
	
	
		let current_filters: FiltroTypes = defaultFilter ? defaultFilter : {};

		
	
		const handleExerciseChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.exercicio = selected;
				onFilterChange?.('exercicio', selected)
			} else {
				onFilterChange?.('exercicio', [])
				delete current_filters.exercicio
			}
		};
	
		const handleProtocolsChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.protocolo = selected;
				onFilterChange?.('protocolo', selected)
			} else {
				onFilterChange?.('protocolo', [])
				delete current_filters.protocolo
			}
		};
	
		const handleCargosChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.cargo = selected;
				onFilterChange?.('cargo', selected)
			} else {
					onFilterChange?.('cargo', [])
				delete current_filters.cargo
			}
		};
	
		const handleSexoChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.sexo = selected;
				onFilterChange?.('sexo', selected)
			} else {
					onFilterChange?.('sexo', [])
				delete current_filters.sexo
			}
		};
	
		const handleCondicionamentoChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.condicionamento = selected;
				onFilterChange?.('condicionamento', selected)
			} else {
				onFilterChange?.('condicionamento', [])
				delete current_filters.condicionamento
			}
		};
	
		const handleEtiquetasChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.etiqueta = selected;
				onFilterChange?.('etiqueta', selected)
			} else {
				onFilterChange?.('etiqueta', [])
				delete current_filters.etiqueta
			}
		};
	
		const handleAvaliadorChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.avaliador = selected;
				onFilterChange?.('avaliador', selected)
			} else {
				onFilterChange?.('avaliador', [])
				delete current_filters.avaliador
			}
		};
	
		const handleArticulacaoChange = (selected: any) => {
			if (selected.length > 0) {
				current_filters.articulacao = selected;
				onFilterChange?.('articulacao', selected)
			} else {
				onFilterChange?.('articulacao', [])
				delete current_filters.articulacao
			}
		};
	
		const handleEntranceDoor = (selected: any) => {
			if (selected.length > 0) {
				current_filters.entrance_door_data = selected;
				onFilterChange?.('entrance_door_data', selected)

			} else {
				onFilterChange?.('entrance_door_data', [])
				delete current_filters.entrance_door_data
			}
		};
	
		const handleGerencias = (selected: any) => {
			if (selected.length > 0) {
				current_filters.gerencias = selected;
				onFilterChange?.('gerencias', selected)

			} else {
				onFilterChange?.('gerencias', [])
				delete current_filters.gerencias
			}
		};
	

		const handleAlteracoes = (selected: any) => {
			if (selected.length > 0) {
				current_filters.alteracoes = selected;
				onFilterChange?.('alteracoes', selected)

			} else {
				onFilterChange?.('alteracoes', [])
				delete current_filters.alteracoes
			}
		};
	
		const handleDataPickerChange = (selected: any) => {
			current_filters.data = selected;
			onFilterChange?.('data', selected)
			onFilterChange?.('ano',[])
			onFilterChange?.('mes', [])
		};
	
		const ApplyFilter = (() => {
			if ((current_filters.mes || current_filters.ano) && current_filters.data) {
				delete current_filters.ano
				delete current_filters.mes
			}
		})

		const LOOKUP_MAP = {
			protocolo: {
				lista: protocolos_dynalabs,
				idKey: "ID_PROTOCOLO",
				labelKey: "PROTOCOLO_TITULO_PT"
			},
			exercicio: {
				lista: exercicios,
				idKey: "ID_EXERCICIO",
				labelKey: "EXERCICIO_TITULO_PT"
			},
			cargo: {
				lista: cargos_dynalabs,
				idKey: "ID_CARGO",
				labelKey: "CARGO_TITULO"
			},
			sexo: {
				lista: sexos,
				idKey: "value",
				labelKey: "label"
			},
			condicionamento: {
				lista: condicionamentos,
				idKey: "value",
				labelKey: "label"
			},
			entrance_door_data: {
				lista: entrance_door_data,
				idKey: "ID_PORTA_ENTRADA",
				labelKey: "PORTA_ENTRADA_TITULO"
			},
			gerencias: {
				lista: gerencias,
				idKey: "ID_GERENCIA",
				labelKey: "GERENCIA_TITULO"
			},
			alteracoes: {
				lista: alteracoes,
				idKey: "value",
				labelKey: "label"
			},
			etiqueta: {
				lista: etiquetas,
				idKey: "ID_ETIQUETA",
				labelKey: "ETIQUETA_NOME"
			},
		} as const;

			const gerarLegenda = (dataLegend: { filtros_gerais: any[]; filtros_especificos: any[]; }) => {
				const filtrosGerais = dataLegend.filtros_gerais.join(" • ");
				const filtrosEspecificos = dataLegend.filtros_especificos.join(" • ");
		
				const legendaFinal = [];
		
				if (filtrosGerais) {
					legendaFinal.push(`Filtros Aplicados Gerais: ${filtrosGerais}`);
				}
		
				if (filtrosEspecificos) {
					legendaFinal.push(`Filtros Específicos: ${filtrosEspecificos}`);
				}
		
				return legendaFinal;
			};
		
		
			const HandlerFilterLegendCurrentPanel = ()=> {

				const LABELS = {
					protocolo: "Protocolos",
					exercicio: "Exercícios",
					cargo: "Cargo",
					sexo: "Sexo",
					condicionamento: "Condicionamento",
					etiqueta: "Etiquetas",
					avaliador: "Avaliadores",
					articulacao: "Articulações",
					data: "Data",
					entrance_door_data: "Portas de entrada",
					gerencias: "Gerências",
					alteracoes: "Alterações"
				} as const;
		
				type ChaveLabel = keyof typeof LABELS;
		
				const GERAIS_KEYS: ChaveLabel[] = [
					"protocolo", "exercicio", "cargo", "sexo", "condicionamento",
					"etiqueta", "avaliador", "alteracoes" , "data", "entrance_door_data", "gerencias"
				];
		
				const ESPECIFICOS_KEYS: ChaveLabel[] = ["articulacao" ];
		
				const formatDate = (iso: string) =>
					new Date(iso).toLocaleDateString("pt-BR", {
						day: "2-digit",
						month: "short"
					}).replace('.', '');
		
				const dataLegend = {
					filtros_gerais: [] as string[],
					filtros_especificos: [] as string[]
				};
		
				GERAIS_KEYS.forEach((key) => {
					const valor:any = appliedFilters?.FILTRO_DASH_VALORES[key];
					const label = LABELS[key];
		
					if (key === "data") {
						let from = valor?.from;
						let to = valor?.to;

						if (!from || !to) {
							from = startOfMonth(new Date()).toISOString();
							to = new Date().toISOString();

						}

						const dataFormatada = `${formatDate(from)} - ${formatDate(to)}`;
						dataLegend.filtros_gerais.push(`${label}: ${dataFormatada}`);
					}else if (Array.isArray(valor) && valor.length > 0) {
							if (key in LOOKUP_MAP) {
								const { lista, idKey, labelKey } = LOOKUP_MAP[key as keyof typeof LOOKUP_MAP];

								const nomesTraduzidos = valor.map((id: number) => {
									const item = lista.find((obj: any) => obj[idKey] === id);
									return item?.[labelKey] ?? `#${id}`;
								});

								dataLegend.filtros_gerais.push(`${label}: ${nomesTraduzidos.join(', ')}`);
							} else {
								dataLegend.filtros_gerais.push(`${label}: ${valor.join(', ')}`);
							}
						}
				});
		
				ESPECIFICOS_KEYS.forEach((key) => {
					const valor = appliedFilters?.FILTRO_DASH_VALORES[key];
					const label = LABELS[key];
		
					if (Array.isArray(valor) && valor.length > 0) {
						dataLegend.filtros_especificos.push(`${label}: ${valor.join(', ')}`);
					}
				});
				const legenda = gerarLegenda(dataLegend);
		
				return legenda
				
			}
				

	return (
			<div className={`flex w-full flex-col `}>
				{
					customPanel
					?
						!editPanel
							?
								<div className={` w-full flex flex-row
									`}
									

								>		
										<div className={`w-[75%] flex-col`}>
											<div className={`w-full text-[#9497A4]`}>
												{HandlerFilterLegendCurrentPanel()[0]}
											</div>
											<div className={`w-full text-[#9497A4]`}>
												{HandlerFilterLegendCurrentPanel()[1]}
											</div>
										</div>
										<div 
											onClick={()=>{ setEditPanel?.()	}}
											className={`flex h-full w-[25%] items-center justify-end text-[#001574] hover:text-[#0023BD] active:text-[#000E4B] underline cursor-pointer`}
										>
											Editar painel 
											<EditFilterPanel className={`w-4 h-4 ml-2 mt-1 `} />
										</div>
								</div>
							:
						<>	
							<div>
								<p className={`flex text-start mb-4 ml-2 relative`}  style={
									{ color: '#9497A4', fontSize: '1rem' }
								}>
									{'1. Personalize o seu painel adicionando'}<p className={`font-bold ml-1`}>{'filtros'}</p>
									<p className={`text-[#00A377] underline absolute right-0 cursor-pointer`}
									onClick={()=>{ setClearFilter(true), setTimeout(()=>{setClearFilter(false)},500) }}
									>
										Limpar
									</p>
								</p>

							</div>
							<div className={`flex flex-wrap gap-4 w-full  pb-8`}>
								<DatePickerWithRange onPickerChange={handleDataPickerChange}  clearFilter={clearFilter} customIcon={Calendar} currentDateRange={defaultFilter?.data} />
								<MultiSelect title={"Articulações"} customPanel customIcon={Calendar} clearFilter={clearFilter} data={articulacoes} CurrentSelected={defaultFilter?.articulacao} onSelectChange={handleArticulacaoChange} Searchable />
								<MultiSelect title={"Protocolo"}  customPanel IconLucide={ListCheck} clearFilter={clearFilter}  data={protocolos_dynalabs} CurrentSelected={defaultFilter?.protocolo} onSelectChange={handleProtocolsChange} Searchable />
								<MultiSelect title={"Exercício"} customPanel customIcon={Fitness}  clearFilter={clearFilter} data={exercicios} CurrentSelected={defaultFilter?.exercicio} onSelectChange={handleExerciseChange} Searchable />
								<MultiSelect title={"Cargo"}  customPanel customIcon={Cargo} clearFilter={clearFilter} data={cargos_dynalabs} CurrentSelected={defaultFilter?.cargo} onSelectChange={handleCargosChange} Searchable />
								<MultiSelect title={"Sexo"} customPanel customIcon={Sexo} clearFilter={clearFilter} data={sexos} CurrentSelected={defaultFilter?.sexo} onSelectChange={handleSexoChange} Searchable />
								<MultiSelect title={"Nível de cond."} customPanel clearFilter={clearFilter} customIcon={NivelCond} data={condicionamentos} CurrentSelected={defaultFilter?.condicionamento} onSelectChange={handleCondicionamentoChange} Searchable />
								<MultiSelect title={"Avaliador"} customPanel clearFilter={clearFilter} customIcon={EvaluatorDash} data={avaliadores} CurrentSelected={defaultFilter?.avaliador} onSelectChange={handleAvaliadorChange} Searchable />
								<MultiSelect title={"Porta de entrada"}customPanel clearFilter={clearFilter} customIcon={DoorOpen} data={entrance_door_data} CurrentSelected={defaultFilter?.entrance_door_data} onSelectChange={handleEntranceDoor} Searchable />
								<MultiSelect title={"Gerências"} customPanel clearFilter={clearFilter} customIcon={Management} data={gerencias} CurrentSelected={defaultFilter?.gerencias} onSelectChange={handleGerencias} Searchable />
								<MultiSelect title={"Alterações"}  customPanel clearFilter={clearFilter} IconLucide={"Alteracoes"} data={alteracoes} CurrentSelected={defaultFilter?.alteracoes} onSelectChange={handleAlteracoes} Searchable />
							</div>
							<div>
								<p className={`flex text-start mb-4 ml-2 relative`}  style={
									{ color: '#9497A4', fontSize: '1rem' }
								}>
									{'2. Personalize o seu painel adicionando '}<p className={`font-bold ml-1`}>{'etiquetas'}</p> 
									<p className={`text-[#00A377] underline absolute right-0 cursor-pointer`}
										onClick={()=>{ setClearTag(true), setTimeout(()=>{setClearTag(false)},500) }}
									>
										Limpar
									</p>
								</p>

							</div>
							<div className={`pb-4`}>
								<Tags data={etiquetas} customPanel  clearFilter={clearTag} CurrentSelected={defaultFilter?.etiqueta} onSelectChange={handleEtiquetasChange}/>
							
							</div>
							<div>
								<p className={`flex text-start mb-4 ml-2`}  style={
									{ color: '#9497A4', fontSize: '1rem' }
								}>
									{'3. Escolha quais'}<p className={`font-bold ml-1 mr-1`}>{'informações'}</p> deseja visualizar
								</p>

							</div>
						</>
					: <></>

					
							
				}
			</div>
	)
};
export default CustomizeFiltersPanel;